import { useState } from 'react';
import { handleIdeaFileUpload } from '../../utils';
import { classify } from '../../../../../common/Utility';

export type CategoryInput = {
  name?: string;
  description?: string;
  merchantId?: string;
  horizontalImageUrl?: string;
  verticalImageUrl?: string;
};

const UploadIdeasFile = ({
  allExistingIdeas,
  allExistingCategories,
  setAllIdeas,
  closeModal,
}: {
  allExistingIdeas: Idea[];
  allExistingCategories: IdeaCategory[];
  setAllIdeas: (newList: Idea[]) => void;
  closeModal: () => void;
}) => {
  const [fileUploading, setFileUploading] = useState(false);
  const [uploadErrorMessage, setUploadErrorMessage] = useState('');

  console.log('UPLOAD IDEAS FILE');

  async function processUpload(e: React.ChangeEvent<HTMLInputElement>) {
    console.log('PROCESSING UPLOAD');
    e.preventDefault();
    setFileUploading(true);
    const targetFile = e.target.files[0];

    handleIdeaFileUpload(
      targetFile,
      allExistingIdeas,
      allExistingCategories,
      setAllIdeas,
      (err: string) => {
        setUploadErrorMessage(err);
        setFileUploading(false);
      },
      () => {
        setFileUploading(false);
        closeModal();
      }
    );
  }

  return (
    <div className="flex flex-col items-start p-6">
      <div className="flex flex-col gap-0 mb-4 w-full mt-6">
        <h1 className="underline">UPLOAD FILE</h1>

        <h4 className="mb-0 mt-6">
          Columns must be the following name and order:
        </h4>
        <p className="mb-0">
          'Name', 'Categories', 'Description', 'Image URL', 'Voucher Code',
          'Merchant ID', 'Offer ID'
        </p>

        <h4 className="mb-0 mt-4">The following fields are mandatory:</h4>
        <p className="mb-4">'Name', 'Categories', 'Description', 'Image URL'</p>

        <input
          className="my-4"
          type={'file'}
          accept={'.csv, .xlsx'}
          // onClick={(e) => {
          //   e.target = null;
          // }}
          onChange={processUpload}
        />

        {fileUploading && <h1>LOADING</h1>}

        {uploadErrorMessage && (
          <p className={classify(['text-red-500'])}>{uploadErrorMessage}</p>
        )}
      </div>
    </div>
  );
};
export default UploadIdeasFile;
